module.exports = __webpack_public_path__ + "static/img/产品界面图_06@2x.f8cd7560.png";